'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import allNutrients from '@app/tables/nutrients';
import { serveGrams, serveThreshold, SLOT_NUTRNOS } from '@utils/Monash';

import './MonashFoodDetailModal.scss';

// Same six FODMAPs, same order, as the entry tool rows
const DETAIL_NUTRNOS = ['FRC', 'LAC', 'MAN', 'SOR', 'OLG', 'OLF'];

const LIGHT_LABELS = { 1: 'green', 2: 'amber', 3: 'red' };

const shortLabel = (nutrNo) => allNutrients[nutrNo].NutrDesc.replace('FODMAP ', '');

// The numbers behind a Monash browser row: what a pick would prefill into the
// entry tool per FODMAP, plus the raw per-serve traffic lights those
// thresholds derive from. Stacks on top of MonashBrowserModal.
export default class MonashFoodDetailModal extends Component {
    static propTypes = {
        food: PropTypes.object.isRequired,
        closeModal: PropTypes.func.isRequired,
    };

    renderThresholds = () => (
        <div className="derived-thresholds">
            {DETAIL_NUTRNOS.map((nutrNo) => {
                const threshold = serveThreshold(this.props.food, nutrNo);

                return (
                    <span key={nutrNo} className="threshold-chip p3" data-level={threshold ? threshold.level : 'none'}>
                        {shortLabel(nutrNo)}:{' '}
                        {threshold ? `${LIGHT_LABELS[threshold.level + 1]} at ${threshold.size}g` : 'no data'}
                    </span>
                );
            })}
        </div>
    );

    renderServeRow = (serve, serveIdx) => (
        <tr key={serveIdx}>
            <td className="serve-title" title={serve.comment}>
                {serve.title}
            </td>
            <td className="serve-grams">{serveGrams(serve)}g</td>
            {DETAIL_NUTRNOS.map((nutrNo) => {
                const light = serve.fodmap[SLOT_NUTRNOS.indexOf(nutrNo)];

                return (
                    <td key={nutrNo} className="serve-light-cell">
                        <i className="serve-light" data-light={light} title={LIGHT_LABELS[light] || 'untested'} />
                    </td>
                );
            })}
        </tr>
    );

    render = () => {
        const { food, closeModal } = this.props;

        return (
            <Modal
                isOpen={true}
                onRequestClose={closeModal}
                closeModal={closeModal}
                contentLabel="Monash Food Detail"
                className="el-modal el-modal2"
                overlayClassName="el-modal-overlay"
                closeTimeoutMS={250}
            >
                <div className="el-modal-container el-modal2-container monash-food-detail-modal-container">
                    <header>
                        <h2>
                            Monash #{food.food_id}: <em>{food.name}</em>
                        </h2>
                    </header>

                    <div className="el-modal-body-container el-modal2-body-container el-fonts">
                        {this.renderThresholds()}

                        <table className="serves-table p3">
                            <thead>
                                <tr>
                                    <th>Serve</th>
                                    <th>Grams</th>
                                    {DETAIL_NUTRNOS.map((nutrNo) => (
                                        <th key={nutrNo}>{shortLabel(nutrNo)}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>{food.serves.map(this.renderServeRow)}</tbody>
                        </table>
                    </div>

                    <footer>
                        <button className="el-modal-cancel-btn" onClick={closeModal}>
                            close
                        </button>
                    </footer>
                </div>
            </Modal>
        );
    };
}
